import { DateTime } from "luxon";

export function getBackfillDate(backfillDays: number) {
  return DateTime.utc().startOf("day").minus({ days: backfillDays }).toISO();
}
